import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c05ab546"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["alt", "src"]




export default /*#__PURE__*/_defineComponent({
  __name: 'FlipButton',
  props: {
    icon: null,
    alt: null,
    label: null,
    styleFront: null,
    styleBack: null,
    class: null
  },
  emits: ['buttonClick'],
  setup(__props: any, { emit }) {

const props = __props as {
  icon: string;
  alt?: string;
  label: string;
  styleFront?: {
    border?: string,
    color?: string,
    fontSize?: string,
    fontWeight?: string,
  };
  styleBack?: {
    color?: string,
  }
  class?: string,
};



/**
 * icon: name of icon file
 * label: display name of front button
 * styleFront: change style of front button
 * styleBack: change style of back button
*/


const onButtonClick = (event: Event) => {
  emit('buttonClick', event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(`flip-btn ${props.class}`),
    type: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (onButtonClick($event)))
  }, [
    _createElementVNode("span", {
      class: "flip-btn-back",
      style: _normalizeStyle(`
        color: ${props.styleFront?.color};
        font-size: ${props.styleFront?.fontSize};
        font-weight: ${props.styleFront?.fontWeight};
      `)
    }, _toDisplayString(props.label), 5),
    _createElementVNode("img", {
      class: _normalizeClass(`icon iconBG ${props.styleBack?.color||'color-orange'} flip-btn-front`),
      alt: props.alt || props.label,
      src: require(`../assets/media/icons/${props.icon}`)
    }, null, 10, _hoisted_1)
  ], 2))
}
}

})